function bookATable() {

    $('#book-a-table-selector li').on('click', function (e) {
        e.preventDefault();

        const venueId = $(this).attr('id');
        const venueName = $(this).text();

        $('#book-a-table-selector').hide();
        $("[data-venue='" + venueId + "']").addClass('active'); 
        $("[data-venue='" + venueId + "']").find('h3').text(venueName); 
    });

    $('.back-to-venue-list').on('click', function (e) {
        e.preventDefault();

        $('.widget-container').removeClass('active');
        $('#book-a-table-selector').show();
    });
}